import { useMutation, useQueryClient } from '@tanstack/react-query';
import ChatService from '@/services/ChatService';
import type { ChatMessageOptions } from '@/services/ChatService';
import { OUTREACH_KEYS } from '@/state/data/outreach/keys';
import { scheduleInvalidate } from '@/state/data/_shared/wf-race';

// Async via Tier 4 careteam_message_sent → n8n. See _shared/wf-race.ts.
// ChatPanel maintains its own optimisticMessages local merge.

export function useSendChatMessage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: {
      withingsUserId: string | number;
      message: string;
      options?: ChatMessageOptions;
    }) => ChatService.sendChatMessage(vars.withingsUserId, vars.message, vars.options),
    onSettled: (_d, _e, vars) => scheduleInvalidate(qc, OUTREACH_KEYS.log(vars.withingsUserId)),
  });
}
